import React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import SimpleArtist from '@common/types/artist/simple-artist';

// Store
import AppState from '@webapp/store/state';
import {
  DeleteMerch,
  PublishProduct,
} from '@webapp/store/merch/action-creators';

import MobileInfoRow from './mobile-row/info-row';
import MerchDesktopInfoRow from './desktop-view/info-row';
import { NFTType } from '@webapp/pages/catalog/nft-tab';

declare type NFTCatalogInfoRowProps = {
  // TODO: DEVTEAM-603 - item needs to be integrated with the correct type.
  item: NFTType;
  artist: SimpleArtist;
  isMobile: boolean;
  isArtist?: boolean;
  isListOpen: boolean;
  openList: () => void;
  handleCatalogMenu: (action: string, release: any) => void;
};

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleCatalogMenu: (action: string, release: any) => {
    switch (action) {
      case 'edit':
        dispatch(push(`/merch/edit/${release.id}`));
        return;
      case 'subscribe-and-publish':
        dispatch(new PublishProduct(release.artistId, release.id));
        return;
      case 'cancel-publishing':
        dispatch(new DeleteMerch(release.artistId, release.id));
        return;
      default:
        return;
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function NFTCatalogInfoRow({
  item,
  artist,
  isArtist,
  isMobile,
  isListOpen,
  openList,
  handleCatalogMenu,
}: NFTCatalogInfoRowProps) {
  return isMobile ? (
    <MobileInfoRow
      item={item}
      artist={artist}
      isListOpen={isListOpen}
      openList={openList}
      isArtist={isArtist}
      handleCatalogMenu={handleCatalogMenu}
    />
  ) : (
    <MerchDesktopInfoRow
      item={item}
      artist={artist}
      isListOpen={isListOpen}
      openList={openList}
      isArtist={isArtist}
      handleCatalogMenu={handleCatalogMenu}
    />
  );
});
